import { render, staticRenderFns } from "./roomSummate.vue?vue&type=template&id=1cd6f3f5&"
import script from "./roomSummate.vue?vue&type=script&lang=js&"
export * from "./roomSummate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports